/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ClassifyProductGenericProductQueryVariables = Exact<{
  name: string;
  subFamily: string;
  brand?: string | null | undefined;
  description?: string | null | undefined;
  labels?: Array<string> | string | null | undefined;
}>;


export type ClassifyProductGenericProductQuery = { classifyProductGenericProduct: { status: string, genericProductCode: string | null, reason: string | null } | null };


export const ClassifyProductGenericProductDocument = /*#__PURE__*/ gql`
    query ClassifyProductGenericProduct($name: String!, $subFamily: String!, $brand: String, $description: String, $labels: [String!]) {
  classifyProductGenericProduct(
    name: $name
    subFamily: $subFamily
    brand: $brand
    description: $description
    labels: $labels
  ) {
    status
    genericProductCode
    reason
  }
}
    `;

/**
 * __useClassifyProductGenericProductQuery__
 *
 * To run a query within a React component, call `useClassifyProductGenericProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useClassifyProductGenericProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClassifyProductGenericProductQuery({
 *   variables: {
 *      name: // value for 'name'
 *      subFamily: // value for 'subFamily'
 *      brand: // value for 'brand'
 *      description: // value for 'description'
 *      labels: // value for 'labels'
 *   },
 * });
 */
export function useClassifyProductGenericProductQuery(baseOptions: Apollo.QueryHookOptions<ClassifyProductGenericProductQuery, ClassifyProductGenericProductQueryVariables> & ({ variables: ClassifyProductGenericProductQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClassifyProductGenericProductQuery, ClassifyProductGenericProductQueryVariables>(ClassifyProductGenericProductDocument, options);
      }
export function useClassifyProductGenericProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClassifyProductGenericProductQuery, ClassifyProductGenericProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClassifyProductGenericProductQuery, ClassifyProductGenericProductQueryVariables>(ClassifyProductGenericProductDocument, options);
        }
// @ts-ignore
export function useClassifyProductGenericProductSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ClassifyProductGenericProductQuery, ClassifyProductGenericProductQueryVariables>): Apollo.UseSuspenseQueryResult<ClassifyProductGenericProductQuery, ClassifyProductGenericProductQueryVariables>;
export function useClassifyProductGenericProductSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ClassifyProductGenericProductQuery, ClassifyProductGenericProductQueryVariables>): Apollo.UseSuspenseQueryResult<ClassifyProductGenericProductQuery | undefined, ClassifyProductGenericProductQueryVariables>;
export function useClassifyProductGenericProductSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ClassifyProductGenericProductQuery, ClassifyProductGenericProductQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ClassifyProductGenericProductQuery, ClassifyProductGenericProductQueryVariables>(ClassifyProductGenericProductDocument, options);
        }
export type ClassifyProductGenericProductQueryHookResult = ReturnType<typeof useClassifyProductGenericProductQuery>;
export type ClassifyProductGenericProductLazyQueryHookResult = ReturnType<typeof useClassifyProductGenericProductLazyQuery>;
export type ClassifyProductGenericProductSuspenseQueryHookResult = ReturnType<typeof useClassifyProductGenericProductSuspenseQuery>;
export type ClassifyProductGenericProductQueryResult = Apollo.QueryResult<ClassifyProductGenericProductQuery, ClassifyProductGenericProductQueryVariables>;